export const ContractAccountDetail = (props, context) => {
  const store = context.root.$store

  const user = store.getters['users/getCurrentUser']

  const close = () => {
    context.emit('close')
  }
  const openEdit = () => {
    context.emit('openEdit')
  }

  return {
    close,
    openEdit,
    user
  }
}
